import type { AnnotationTarget } from "@carbon6/c6-frontend-design/annotation";
import { AnnotationIdentityRegistry } from "./annotationIdentity";

export const ANNOTATION_TARGET_COLORS = [
  0x22c55e, 0x3b82f6, 0xf59e0b, 0xec4899, 0xa855f7, 0x14b8a6, 0xef4444,
] as const;

export const MAX_ANNOTATION_TARGETS = ANNOTATION_TARGET_COLORS.length;

export type RegistryAnnotationTarget = AnnotationTarget & Readonly<{ objId: number }>;

export function annotationTargetColor(objId: number): number {
  const index = Math.abs(objId) % ANNOTATION_TARGET_COLORS.length;
  return ANNOTATION_TARGET_COLORS[index];
}

export function createAnnotationTargets(
  identities: AnnotationIdentityRegistry,
): readonly RegistryAnnotationTarget[] {
  return ANNOTATION_TARGET_COLORS.map((color, objId) => ({
    id: identities.targetId(objId),
    objId,
    label: String(objId + 1),
    color,
  }));
}
